import AppStoreBadgeLink from './AppStoreBadgeLink';

export default AppStoreBadgeLink;
